<pcs-alert></pcs-alert>
<pcs-global-loader></pcs-global-loader>
<pcs-modal-root></pcs-modal-root>
<router-outlet></router-outlet>
